import { useMemo, useEffect, useContext, memo } from 'react';
import { generateId } from '@agilepoint/utils-common';
import { IToolbarCommandProps } from './types';
import { ToolbarContext } from './context';

export const ToolbarCommand = memo((props: IToolbarCommandProps) => {
    const { upsert, remove } = useContext(ToolbarContext);
    const id = useMemo(generateId, []);

    useEffect(() => () => {
        remove(id);
    }, [id, remove]);

    useEffect(() => { upsert({ ...props, position: props.position || 'default', id }); }, [props, id, upsert]);

    return null;
});

ToolbarCommand.displayName = 'ToolbarCommand';
